import { generateUtilityClasses } from '@mui/material';

export const paginationDisplayedRowsClasses = generateUtilityClasses('PaginationDisplayedRows', [
  'root',
  'highlight',
]);
